export interface DrawLineCheckpointInterface {
    x: number;
    y: number;
}